<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Добавление и редактирование сотрудника</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Без сотрудников не&nbsp;получится использовать онлайн-запись на&nbsp;услуги. Также добавить сотрудников
              можно просто для просмотра клиентами информации о&nbsp;них на&nbsp;сайте.
            </p>

            <p>Давайте добавим сотрудника в&nbsp;ваш проект.</p>

            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Сотрудники&raquo;. Если вы&nbsp;еще не&nbsp;добавляли
              сотрудников&nbsp;&mdash; на&nbsp;появившейся странице нажмите &laquo;Добавить сотрудника&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Если вы&nbsp;уже добавляли сотрудников&nbsp;&mdash; на&nbsp;появившейся странице нажмите &laquo;Добавить
            сотрудника&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="osnovnaya-informacija"
            class="typography__headline2"
          >
            Основная информация
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              В&nbsp;основной информации фамилия и&nbsp;имя сотрудника, его должность и&nbsp;телефон обязательные для
              заполнения данные.
            </p>

            <p>
              Электронную почту стоит заполнить, чтобы сотрудник мог получать на&nbsp;неё уведомления о&nbsp;записях.
            </p>

            <p>Также можно заполнить текстовое описание, загрузить его фотографию и&nbsp;другую информацию.</p>

            <p>
              Эти элементы будут использоваться в&nbsp;созданном сайте при онлайн-записи или просмотре информации
              о&nbsp;сотрудниках, поэтому лучше заполнять максимально подробно.
            </p>

            <p>
              Настройкой онлайн-записи управляется доступен сотрудник к&nbsp;ней или нет. При выключенном состоянии
              сотрудник не&nbsp;будет виден в&nbsp;записи на&nbsp;услуги, но&nbsp;о&nbsp;нем можно будет посмотреть
              информацию в&nbsp;списке сотрудников. По-умолчанию активно.
            </p>

            <p>
              Настройкой активности можно быстро полностью скрывать сотрудника с&nbsp;сайта и&nbsp;отключать его
              от&nbsp;онлайн-записи. По-умолчанию активно.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>При первом добавлении сотрудника список должностей персонала проекта будет пустым.</p>

            <p>
              В&nbsp;появившемся окне добавьте новую должность. После добавления выберите её&nbsp;и&nbsp;нажмите
              &laquo;Готово&raquo;.
            </p>

            <p>
              Если в&nbsp;будущем какие-то должности станут неактуальны&nbsp;&mdash; их&nbsp;всегда можно удалить
              из&nbsp;списка в&nbsp;этом&nbsp;же окне.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="uslugi"
            class="typography__headline2"
          >
            Услуги
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              При первом добавлении сотрудника, скорее всего, вы&nbsp;еще не&nbsp;добавляли услуги и&nbsp;выбирать будет
              не&nbsp;из&nbsp;чего.
            </p>

            <p>
              Это необязательный блок, поэтому советую пока оставить его без внимания, а&nbsp;услуги добавить позже при
              их&nbsp;настройке, там&nbsp;же можно будет выбрать сотрудников для нужных услуг.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>Если у&nbsp;вас уже были добавлены услуги&nbsp;&mdash; нажмите &laquo;Выбрать услуги&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;появившемся окне выберите услуги, оказываемые добавляемым сотрудником и&nbsp;нажмите
            &laquo;Готово&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-8.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            После выбора услуг, вы&nbsp;увидите их&nbsp;с&nbsp;возможностью быстро удалить по&nbsp;крестику
            из&nbsp;списка ненужные.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-9.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="raspisaniye"
            class="typography__headline2"
          >
            Расписание
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В&nbsp;этом блоке настраивается базовое глобальное рабочее расписание сотрудника для онлайн записи.</p>

            <p>
              Если вы&nbsp;просто хотите разместить информацию о&nbsp;сотруднике на&nbsp;сайте с&nbsp;его рабочими
              часами&nbsp;&mdash; отключите в&nbsp;блоке с&nbsp;основной информацией его онлайн-запись и&nbsp;заполните
              этот блок.
            </p>

            <p>
              Заполните начало и&nbsp;конец рабочего дня сотрудника. Добавьте при необходимости перерыв, во&nbsp;время
              которого сотрудник будет не&nbsp;доступен для записи.
            </p>

            <p>
              Выберите в&nbsp;каких филиалах будет работать сотрудник. Если вы&nbsp;еще не&nbsp;добавляли рабочие
              адреса&nbsp;&mdash;
              <BaseLink
                target="_blank"
                to="/faq/articles/kontakty-i-dannye-filialov"
                >обязательно сделайте это</BaseLink
              >, без них не&nbsp;получится использовать онлайн-запись.
            </p>

            <p>
              На&nbsp;календаре справа проставьте будущие рабочие дни сотрудника. Это нужно будет делать постоянно при
              появлении актуального рабочего расписания.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-10.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;окне выбора адреса также можно быстро добавить новый, не&nbsp;забудьте после
              <BaseLink
                target="_blank"
                to="/faq/articles/kontakty-i-dannye-filialov"
                >заполнить все его данные</BaseLink
              >.
            </p>

            <p>После выбора нужных филиалов нажмите &laquo;Готово&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-11.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-12.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="uvedomleniya-i-dobavlenie-sotrudnika"
            class="typography__headline2"
          >
            Уведомления и&nbsp;добавление сотрудника
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Уведомления будут поступать на&nbsp;электронную почту, указанную в&nbsp;основной информации. Если
              вы&nbsp;её&nbsp;там заполняли&nbsp;&mdash; после добавления сотрудника она здесь появится тоже.
            </p>

            <p>
              Активность уведомлений по-умолчанию включена для всех видов. Проверьте, возможно понадобится что-то
              изменить.
            </p>

            <p>
              Как заполните всю нужную информацию о&nbsp;сотруднике, нажмите &laquo;Добавить&raquo; в&nbsp;самом низу
              страницы. После успешного добавления увидите в&nbsp;правом верхнем углу уведомление.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-13.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="redaktirovaniye-sotrudnika"
            class="typography__headline2"
          >
            Редактирование сотрудника
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              После добавления сотрудника, вы&nbsp;сможете найти его в&nbsp;<BaseLink
                target="_blank"
                to="/faq/articles/spisok-sotrudnikov-i-ikh-dannye"
                >списке сотрудников</BaseLink
              >.
            </p>

            <p>Отсюда можно быстро перейти к&nbsp;редактированию по&nbsp;иконке карандаша справа.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavleniye-i-redaktirovaniye-sotrudnika-14.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С&nbsp;добавлением сотрудника разобрались. Самое время перейти к&nbsp;изучению
            <BaseLink
              target="_blank"
              to="/faq/articles/spisok-sotrudnikov-i-ikh-dannye"
              >списка сотрудников и&nbsp;просмотра их&nbsp;данных </BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Сотрудники",
    url: "/faq/categories/sotrudniki",
  },
  {
    name: "Добавление и&nbsp;редактирование сотрудника",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Основная&nbsp;информация",
    url: "osnovnaya-informacija",
  },
  {
    name: "Услуги",
    url: "uslugi",
  },
  {
    name: "Расписание",
    url: "raspisaniye",
  },
  {
    name: "Уведомления&nbsp;и&nbsp;добавление сотрудника",
    url: "uvedomleniya-i-dobavlenie-sotrudnika",
  },
  {
    name: "Редактирование&nbsp;сотрудника",
    url: "redaktirovaniye-sotrudnika",
  },
];

const relatedArticles = [
  {
    name: "Список сотрудников и&nbsp;их данные",
    slug: "spisok-sotrudnikov-i-ikh-dannye",
  },
  {
    name: "Расписание сотрудника",
    slug: "raspisaniye-raboty",
  },
  {
    name: "Уведомления сотрудника",
    slug: "uvedomleniya-sotrudnika",
  },
];

useSeoMeta({
  title: "Добавление и редактирование сотрудника",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

p a {
  display: contents;
}
</style>
